import { createSlice } from "@reduxjs/toolkit";
import {
  addAutoAtendimentoCliente,
  atendimentos,
  controleAtendimento,
  finalizarAutoAtendimento,
  liberarAutoAtendimento,
  painelControleAutoAtendimento,
  painelControleCliente,
  relatorio,
} from "./thunk";

export const initialState = {
  controleAtendimentoList: [],
  controleAtendimentoClienteList: [],
  controleAtendimentoAutoAtendimentoList: [],
  relatorioList: [],
  maisEmpesa: 0,
};
const ControleAtendimentoSlice = createSlice({
  name: "ControleAtendimentoSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      controleAtendimento.fulfilled,
      (state: any, action: any) => {
        state.controleAtendimentoList = action.payload?.resultados;
        state.maisEmpesa = action.payload?.maisEmpesa;
        state.isControleAtendimentoCreated = false;
        state.isControleAtendimentoSuccess = true;
      }
    );
    builder.addCase(
      painelControleCliente.fulfilled,
      (state: any, action: any) => {
        state.controleAtendimentoClienteList = action.payload;
        state.isControleAtendimentoCreated = false;
        state.isControleAtendimentoSuccess = true;
      }
    );
    builder.addCase(
      painelControleAutoAtendimento.fulfilled,
      (state: any, action: any) => {
        state.controleAtendimentoAutoAtendimentoList = action.payload;
        state.isControleAtendimentoCreated = false;
        state.isControleAtendimentoSuccess = true;
      }
    );
    builder.addCase(relatorio.fulfilled, (state: any, action: any) => {
      state.relatorioList = action.payload;
      state.isControleAtendimentoCreated = false;
      state.isControleAtendimentoSuccess = true;
    });
    builder.addCase(atendimentos.fulfilled, (state: any, action: any) => {
      state.controleAtendimentoList = action.payload;
      state.isControleAtendimentoCreated = false;
      state.isControleAtendimentoSuccess = true;
    });
    builder.addCase(
      finalizarAutoAtendimento.fulfilled,
      (state: any, action: any) => {
        state.isControleAtendimentoCreated = false;
        state.isControleAtendimentoSuccess = true;
      }
    );
    builder.addCase(
      liberarAutoAtendimento.fulfilled,
      (state: any, action: any) => {
        state.isControleAtendimentoCreated = false;
        state.isControleAtendimentoSuccess = true;
      }
    );
    builder.addCase(
      addAutoAtendimentoCliente.fulfilled,
      (state: any, action: any) => {
        state.isCategoriaCreated = true;
        state.isCategoriaAdd = true;
        state.isCategoriaAddFail = false;
      }
    );
  },
});
export default ControleAtendimentoSlice.reducer;
